import styled from 'styled-components/macro';
import getRemovalSource from "../utils/removal_source";
import {themecolors} from "../utils/themecolors";

const TextContent = styled(({className, content, removed, deleted, removalSource, type = "Content"}) => (
    <div className={className} dangerouslySetInnerHTML={{__html: ((removed && !content) || deleted) ? `${type} ${getRemovalSource(removalSource)}` : content}}/>
))`
  blockquote {
    padding: 6px 12px;
    margin: 12px 0;
    border-left: 4px solid ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_5 : themecolors.lighter_border};
  }

  blockquote p {
    margin: 0;
  }
  
  p {
    margin-bottom: 6px;
  }
  
  p:last-of-type {
    margin: 0;
  }
  
  a {
    overflow-wrap: anywhere;
    color: ${({theme}) => theme.color.name === 'dark' ? 'rgb(152 175 198)' : theme.placeholder_link_2};
  }
  
  hr {
    margin-top: 12px;
    margin-bottom: 12px;
    border-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_5 : 'rgb(219, 219, 219)'};
  }
  
`;

export default TextContent;
